// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"afeef066","254":"84e75954","421":"2196a41c"}[chunkId] + ".chunk.css";
};